import { slotConstants } from '../constants';
import { slotService } from '../../services';
import { alertActions } from './';
import { history } from '../../helpers';
import Swal from 'sweetalert2';

export const slotActions = {
	fetchTimeSlots,
	resetSlots,
	createTimeSlot,
	deleteTimeSlot,
	fetchMyCounsellor,
	fetchCounsellorList,
	fetchPublicCounsellorList,
};

function fetchTimeSlots(counsellor_id) {
	return (dispatch) => {
		dispatch(request());

		slotService.fetchTimeSlots(counsellor_id).then(
			(payload) => {
				dispatch(success(payload));
			},
			(error) => dispatch(failure(error.toString()))
		);
	};

	function request() {
		return { type: slotConstants.GETSLOTS_REQUEST };
	}
	function success(payload) {
		return { type: slotConstants.GETSLOTS_SUCCESS, payload };
	}
	function failure(error) {
		return { type: slotConstants.GETSLOTS_FAILURE, error };
	}
}
function resetSlots() {
	return (dispatch) => dispatch({ type: slotConstants.GETSLOTS_RESET });
}
function createTimeSlot(slotDetails) {
	return (dispatch) => {
		slotService.createTimeSlot(slotDetails).then((resp) => {
			if (resp.ok === true) {
				resp.json().then((res) => {
					Swal.fire({
						title:'Saaya Health',
						text: 'Your slot is succesully created!',
						icon:'success',
						onOpen: function () {
							Swal.getPopup().querySelector('.swal2-confirm').setAttribute('id', 'btnSuccess');
							
						},});
					history.push('/home/counsellor');
				});
			}
		});
	};
}

function deleteTimeSlot(slot_id) {
	return (dispatch) => {
		slotService.deleteTimeSlot(slot_id).then((resp) => {
			if (resp.ok === true) {
				dispatch(success())
				Swal.fire({
					title: 'Saaya Health',
					text: 'Your slot is succesully deleted!',
					icon: 'success',
					onOpen: function () {
						Swal.getPopup().querySelector('.swal2-confirm').setAttribute('id', 'btnSuccess');

					},
				})

			} else if (resp.ok === false) {
				resp.json().then((err) => {
					Swal.fire({
						title: 'Your slot cannot be deleted at this time',
						text: `${err.error}`,
						icon: 'error',
						onOpen: function () {
							Swal.getPopup().querySelector('.swal2-confirm').setAttribute('id', 'btnSuccess');

						},
					});

				});
			}
		});
	};

	function request() {
		return { type: slotConstants.DELETEAPPOINTMENTS_REQUEST };
	}
	function success() {
		return { type: slotConstants.DELETE_SLOT_SUCCESS };
	}
	function failure(error) {
		return { type: slotConstants.DELETEAPPOINTMENTS_FAILURE, error };
	}
}

function fetchCounsellorList(language) {
	return (dispatch) => {
		dispatch(request());
		slotService.fetchCounsellorList(language).then(
			(data) => dispatch(success(data)),
			(error) => dispatch(failure(error.toString()))
		);
	};
	function request() {
		return { type: slotConstants.GET_COUNSELLOR_LIST_REQUEST };
	}
	function success(list) {
		return {
			type: slotConstants.GET_COUNSELLOR_LIST_SUCCESS,
			list,
		};
	}
	function failure(error) {
		return { type: slotConstants.GET_COUNSELLOR_LIST_FAILURE, error };
	}
}

function fetchPublicCounsellorList() {
	return (dispatch) => {
		dispatch(request());
		slotService.fetchPublicCounsellorList().then(
			(data) => dispatch(success(data)),
			(error) => dispatch(failure(error.toString()))
		);
	};
	function request() {
		return { type: slotConstants.GET_PUBLIC_COUNSELLOR_LIST_REQUEST };
	}
	function success(list) {
		return {
			type: slotConstants.GET_PUBLIC_COUNSELLOR_LIST_SUCCESS,
			list,
		};
	}
	function failure(error) {
		return { type: slotConstants.GET_PUBLIC_COUNSELLOR_LIST_FAILURE, error };
	}
}

function fetchMyCounsellor() {
	return (dispatch) => {
		dispatch(request());
		slotService.fetchMyCounsellor().then(
			(data) => dispatch(success(data)),
			(error) => dispatch(failure(error.toString()))
		);
	};
	function request() {
		return { type: slotConstants.GET_MY_COUNSELLOR_REQUEST };
	}
	function success(my_counsellor) {
		return {
			type: slotConstants.GET_MY_COUNSELLOR_SUCCESS,
			my_counsellor,
		};
	}
	function failure(error) {
		return { type: slotConstants.GET_MY_COUNSELLOR_FAILURE, error };
	}
}



// WEBPACK FOOTER //
// ./src/store/actions/slot.actions.js